import { createRouter, createWebHistory } from "vue-router";
import type { Router } from "vue-router";

const router: Router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: async () => await import("../views/index.vue"),
      meta: { title: "飞鱼科技" },
    },
    // 网页直充
    {
      path: "/:appId(\\d+)",
      component: async () => await import("../views/direct/computer.vue"),
      meta: { title: "飞鱼充值中心" },
    },
    // 网页直充
    {
      path: "/m/:appId(\\d+)",
      component: async () => await import("../views/direct/mobile.vue"),
      meta: { title: "飞鱼充值中心" },
    },
    // 微信小游戏-客服支付
    {
      path: "/wechat-mini-game",
      component: async () => await import("../views/wechat/index.vue"),
      meta: { title: "游戏物品兑换" },
    },
  ],
});

router.beforeEach((to) => {
  if (!to.meta.title) return;
  document.title = to.meta.title as string;
});

export default router;
